/*
 * Copyright (c) AXA Group Operations Spain S.A.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

function registerTrigrams(container) {
  const language = container.get('Language');
  if (language) {
    language.addModel(
      'Latin',
      'ind',
      'an ang dang  peak  ke meata sedankan di behakberperranngayaneng ya haasaganmenaranyan pn dn ka dtan atat oraalasan baap erhn brhaya  mag ba spenebaas aanuk ntu oretitasakatiabanset unn stern y tek mtukbasiaplambebam  dek akebn mi duntamadalah ikadakebep osa punmemn henddenra elari nda sadi ma a mn tk dn anggtaumangareriasi tiun al adaum a plakariau  nenega bngsta olelehertersidak hanagsadarukatidbatsiaeraeh dapiladilh datusamia i m inlanahauantu ai t da ag dharsemna apaserenakatuaterberlmasrtaegaungnanempn ukuml dg s huka entpatmbaagantaadi sueniukun ihukindar rgai sakundisuani rushansi carnny lain u dik ua lahrikusiembannmerianggalaimina uluaemaemuargdundipa tmatayarbuaruerkrkainiekaa krakkesyatibanasrmaerneses pnus puanuina tamelmuakelk sus ndunakda syadaspemlinut yaramiupuseoaikeorinyauptakipeingtin andikuarilig trsesarantg pa naksain jat p umg mdirksaumukepmumi kecaratm ph pabasesm m'
    );
  }
}

module.exports = registerTrigrams;
